import { collection, query, where, getDocs, addDoc, updateDoc, doc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

// ─── VALUTA SE UNA CONDIZIONE È SODDISFATTA ──────────────────────────────
function valutaCondizione(cond, task) {
  const { field, op, value } = cond;
  let taskVal = "";
  if (field === "priority") taskVal = task.priority || "";
  if (field === "status") taskVal = task.status || "";
  if (field === "assignee") taskVal = task.assigneeId || "";
  if (field === "section") taskVal = task.sectionName || "";
  if (field === "tag") taskVal = (task.tags || []).join(",");

  if (op === "eq") return taskVal === value;
  if (op === "neq") return taskVal !== value;
  if (op === "contains") return taskVal.toLowerCase().includes((value || "").toLowerCase());
  return true;
}

// ─── ESEGUI UN'AZIONE SU UN'ATTIVITÀ ─────────────────────────────────────
async function eseguiAzione(azione, task, orgId) {
  const taskRef = doc(db, "tasks", task.id);
  const { id, param } = azione;

  try {
    if (id === "set_status") {
      await updateDoc(taskRef, { status: param, updatedAt: serverTimestamp() });
    }
    if (id === "set_priority") {
      await updateDoc(taskRef, { priority: param, updatedAt: serverTimestamp() });
    }
    if (id === "assign_to") {
      await updateDoc(taskRef, { assigneeId: param, updatedAt: serverTimestamp() });
    }
    if (id === "add_tag") {
      const tags = [...(task.tags || [])];
      if (!tags.includes(param)) tags.push(param);
      await updateDoc(taskRef, { tags, updatedAt: serverTimestamp() });
    }
    if (id === "add_comment") {
      await addDoc(collection(db, "comments"), {
        taskId: task.id, projectId: task.projectId, organizationId: orgId,
        text: `🤖 Automazione: ${param}`,
        authorId: "system", authorName: "Nexiora Automazioni",
        createdAt: serverTimestamp(),
      });
    }
    if (id === "notify") {
      await addDoc(collection(db, "notifiche"), {
        userId: param, orgId,
        tipo: "automazione",
        titolo: "Regola attivata",
        testo: `Una regola automatica ha modificato l'attività "${task.title}"`,
        taskId: task.id, letta: false,
        createdAt: serverTimestamp(),
      });
    }
  } catch (err) {
    console.warn("Errore esecuzione azione regola:", err);
  }
}

// ─── FUNZIONE PRINCIPALE: VALUTA TUTTE LE REGOLE SU UN'ATTIVITÀ ──────────
export async function valutaRegole(trigger, task, orgId) {
  if (!task || !orgId) return;
  try {
    // Carica tutte le regole attive per questa org
    const q = query(
      collection(db, "regole"),
      where("orgId", "==", orgId),
      where("attiva", "==", true)
    );
    const snap = await getDocs(q);
    const regole = snap.docs.map(d => ({ id: d.id, ...d.data() }));

    for (const regola of regole) {
      // Controlla trigger
      if (regola.trigger !== trigger) continue;

      // Controlla scope — se è per una commessa specifica, verifica che corrisponda
      if (regola.scope === "progetto" && regola.projectId !== task.projectId) continue;

      // Valuta tutte le condizioni (AND logic)
      const tutteOk = (regola.condizioni || []).every(c => valutaCondizione(c, task));
      if (!tutteOk) continue;

      // Esegui tutte le azioni
      for (const azione of (regola.azioni || [])) {
        await eseguiAzione(azione, task, orgId);
      }
    }
  } catch (err) {
    console.warn("Errore valutazione regole:", err);
  }
}

// ─── TRIGGER HELPERS — chiamati dai componenti al momento giusto ──────────
export const Triggers = {
  taskCreated:   (task, orgId) => valutaRegole("task_created", task, orgId),
  taskCompleted: (task, orgId) => valutaRegole("task_completed", task, orgId),
  taskAssigned:  (task, orgId) => valutaRegole("task_assigned", task, orgId),
  taskStatusChanged:   (task, orgId) => valutaRegole("task_status_changed", task, orgId),
  taskPriorityChanged: (task, orgId) => valutaRegole("task_priority_changed", task, orgId),
  subtaskCompleted:    (task, orgId) => valutaRegole("subtask_completed", task, orgId),
  // task_due_today e task_overdue: chiamati da un loop periodico o all'apertura
  checkScadenze: async (orgId) => {
    const oggi = new Date(); oggi.setHours(0,0,0,0);
    const domani = new Date(oggi); domani.setDate(domani.getDate()+1);
    // Carica tutte le task dell'org
    try {
      const snap = await getDocs(query(collection(db,"tasks"),where("organizationId","==",orgId)));
      for (const d of snap.docs) {
        const task = { id: d.id, ...d.data() };
        if (!task.dueDate || task.status === "done") continue;
        const due = new Date(task.dueDate+"T00:00:00");
        if (due.getTime() === oggi.getTime()) {
          await valutaRegole("task_due_today", task, orgId);
        } else if (due < oggi) {
          await valutaRegole("task_overdue", task, orgId);
        }
      }
    } catch(err){ console.warn("checkScadenze error:", err); }
  }
};
